import React, { Component } from 'react';
import Select from 'react-select';

import { Row, Col, Table } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";

import { consultaEst, SolicitarCambio } from "../../funciones/CambioCarrFunction";
import { ConsultaMaterias } from '../../funciones/RetiroFunction';
import { InfoUC } from '../../funciones/InscripcionFunction';
import { Precios } from '../../funciones/AdministracionFunction';
import MensajeRetraso from "../../shared/MensajeRetraso";
import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

import CustomModal from "../../components/Modal/CustomModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Line  from "../../components/Line/Line";

let statusEst= 0;
let deudaTSolic = "";

class CambioCarrera extends Component {
    state = {
        status: {
            icon: "fa fa-spinner fa-spin",
            text: "Verificando, espera por favor",
            class: "custom-alert-info",
            styles:{fontSize:12, position:"absolute", top: 4}
        },
        est: {
            ci: "Cargando",
            name: "Cargando",
        },
        materias: [],
        materiasHistorico: [],
        carrera: {carrera_name: "Cargando"},
        carreras: [],
        valorCarreras: { value: '', label: ' - Selecciona una Carrera - ' },
        button: {icon: "fa fa-edit", text: "Solicitar Cambio"},
        openW: false,
        boton1: {
            icon: "fa fa-check",
            text: "Si"
        },
        carrCambio: "",
        ValorUc: "",
        valorCambioCarr: {
            uc: "",
            bs: ""
        }
    }

    constructor (props) {
        super (props);

        consultaEst((resp) => {
            statusEst = resp[1];
            let nombre2 = resp[0].nombre_2;
            let apellido2 = resp[0].apellido_2;
            if (nombre2 === null) nombre2 = "";
            if (apellido2 === null) apellido2 = "";

            this.setState({
              est:{
                  ci:`${resp[0].nacionalidad} ${resp[0].ci}`,
                  name: `${resp[0].nombre_1} ${nombre2} ${resp[0].apellido_1} ${apellido2}`
              },
              status: resp[2],
              materiasHistorico: resp[3],
              carrera: resp[4],
              carreras: resp[5],
              carrCambio: resp[6]
            })
        })

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        Precios("CAMBIO DE CARRERA", (resp) => {
            this.setState({valorCambioCarr: resp})
        })
    }

    componentDidMount = () => {
        ConsultaDeuda ((resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }

    valorCarreras = (valorCarreras) => {
        this.setState({
            valorCarreras,
            openW: false
        })
    }

    openWindow = () => (e) => {
        if (this.state.valorCarreras.value === "") {
            toast.error("Debes seleccionar primero la carrera",{autoClose: 4000});
            return null;
        }
        this.setState({
            openW: true
        })
    }

    contenido = () => {
        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )

        if (deudaTSolic > 0) return (<MensajeRetraso />)
        
        let { est, materias, materiasHistorico, carrera, carreras, valorCarreras, button, carrCambio,
            ValorUc, valorCambioCarr } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }
        
        let contenidoGral = () => (
            <React.Fragment>
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-info" style={{padding:5}}>Mis Datos</div></Col>
                <Col md ={2} className="custom-mt-10" style={{fontSize: 10}}>
                    <div className="text-danger">Cédula</div>
                    <div>{est.ci}</div>
                </Col>
                <Col md ={7} className="custom-mt-10" style={{fontSize: 10}}>
                    <div className="text-danger">Nombre</div>
                    <div>{est.name}</div>
                </Col>
                <Col md ={3} className="custom-mt-10" style={{fontSize: 10}}>
                    <div className="text-danger">Carrera Actual</div>
                    <div>{carrera.carrera_name}</div>
                </Col>
            </React.Fragment>
        )

        let contenidoInsc = () => {
            ConsultaMaterias ((resp) => {
                if (materias.length === 0) this.setState({  materias: resp })
            })
            
            return(
                materias.map(option => (
                    <tr key={option.id}>
                        <td width="55%" style={styles}>{option.materia}</td>
                        <td width="15%" align="center" style={styles}>{option.seccion}</td>
                        <td width="20%" align="center" style={styles}>{option.tipo}</td>
                        <td width="10%" align="center" style={styles}>{option.uc}</td>
                    </tr>
                ))
            )
        }

        let matHistorico = () => {
            if (materiasHistorico.length === 0) {
                return (
                    <tr>
                        <td width="100%" colSpan={6} style={styles} align="center">No posees ninguna materia registrada en el Archivo Histórico</td>
                    </tr>
                )
            }else{
                return (
                    <tr>
                        <td width="100%" colSpan={6} style={styles} align="center">En desarrollo</td>
                    </tr>
                )
            }
        }

        let contenidoHistorico = () => (
            <React.Fragment>
                <Col md ={12}><div className="custom-alert-success" style={{padding:5}}>Mis Datos Históricos</div></Col>
                <Col md ={12} className="custom-mt-10">
                    <div className="table-responsive">
                        <Table striped hover bordered>
                            <tbody>
                                <tr style={{backgroundColor:"#679a68", color:"#FFF"}}>
                                    <td colSpan={4} width="75%" align="center" style={styles}><strong>ASIGNATURAS</strong></td>
                                    <td colSpan={2} width="25%" align="center" style={styles}><strong>CALIFICACIONES</strong></td>
                                </tr>
                                <tr style={{backgroundColor:"#a3c9a3", color:"#FFF"}}>
                                    <td width="10%" align="center" style={styles}><strong>Código</strong></td>
                                    <td width="30%" align="center" style={styles}><strong>Materia</strong></td>
                                    <td width="15%" align="center" style={styles}><strong>Periodo</strong></td>
                                    <td width="20%" align="center" style={styles}><strong>T.E</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Nota</strong></td>
                                    <td width="15%" align="center" style={styles}><strong>En letras</strong></td>
                                </tr>
                                {matHistorico()}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </React.Fragment>
        )

        let facturacion = () => (
            <Col md={12}>
                <div className="custom-mt-10 text-danger" align="right">
                    Valor actual de la Unidad de Crédito: <span className="badge badge-red">{formatNumber(ValorUc)} Bs.{/*  | {formatReconver(ValorUc)} Bs. */}</span>
                </div>
                <div align="right">
                    Este trámite tiene un costo de <strong>{valorCambioCarr.uc} U.C.</strong> o <strong>{formatNumber(valorCambioCarr.bs)} Bs.{/*  | {formatReconver(ValorUc)} Bs. */}</strong>
                </div>
            </Col>
        )

        switch (statusEst) {
            case 0:
                return(
                    <Row>
                        {contenidoGral()}
                        <div style={{marginTop:30}} align="center"><i className="fa fa-spinner fa-spin"></i> Espera por favor</div>
                    </Row>
                )
            case 1:
                return(
                    <Row>
                        {contenidoGral()}

                        <Col md ={12} className="custom-mt-10"><div className="custom-alert-info" style={{padding:5}}>Detalles de la Inscripción</div></Col>
                        
                        <Col md ={12} className="custom-mt-10">
                            <div className="table-responsive">
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="55%" style={styles}><strong>Materia</strong></td>
                                            <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                            <td width="20%" align="center" style={styles}><strong>Tipo</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>U.C.</strong></td>
                                        </tr>
                                        {contenidoInsc()}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>

                        {/* contenidoHistorico() */}
                        
                        <Col md={12}>
                            <div className="custom-alert-warning custom-mt-10" align="justify" style={{padding:10}}>
                                No puedes realizar ningun cambio de carrera en este periodo debido a que ya realizaste el proceso de inscripción, si deseas realizar algun cambio de este tipo dirígete al departamento de <strong>Control de Estudios</strong>
                            </div>
                        </Col>
                    </Row>
                )
            case 2:
                return(
                    <Row>
                        {facturacion()}
                        {contenidoGral()}
                        {/* contenidoHistorico() */}
                        <Col md ={12} className="custom-mt-10"><div className="custom-alert-info" style={{padding:5}}>Opciones de Cambio de Carrera</div></Col>
                        <Col md={6} className="custom-mt-10">
                            <div className="text-danger" style={{fontSize: 10}}>Selecciona la nueva carrera</div>
                            <Select
                                isSearchable ={true}
                                value={valorCarreras}
                                onChange={this.valorCarreras}
                                options={carreras}
                            />
                        </Col>
                        <Col md={6} style={{marginTop:24}} align="right">
                            <button onClick={this.openWindow()} className="btn btn-primary" style={{borderWidth: 1}} ><i className={button.icon}></i> {button.text}</button>
                        </Col>
                    </Row>
                )
            case 3:
                return(
                    <Row>
                        {contenidoGral()}
                        {/* contenidoHistorico() */}
                        <Col md ={12}><div className="custom-alert-info" style={{padding:5}}>Opciones de cambio de carrera</div></Col>
                        <Col md={12} className="custom-mt-10" align="center">
                            Ya enviaste la solicitud para el siguiente cambio: <strong style={{color:"#a42e2e"}}>{carrera.carrera_name}</strong> <i className="fa fa-arrow-right"></i> <strong style={{color:"#1a7435"}}>{carrCambio}</strong>
                        </Col>
                    </Row>
                )
            case 4:
                return(
                    <Row>
                        {contenidoGral()}
                        {/* contenidoHistorico() */}
                        <Col md ={12}><div className="custom-alert-info" style={{padding:5}}>Opciones de cambio de carrera</div></Col>
                        <Col md={12} className="custom-mt-10" align="center">
                            Ya enviaste la solicitud para el siguiente cambio: <strong style={{color:"#a42e2e"}}>{carrera.carrera_name}</strong> <i className="fa fa-arrow-right"></i> <strong style={{color:"#1a7435"}}>{carrCambio}</strong>
                        </Col>
                    </Row>
                )
            case 6:
                return(
                    <Row style={{color:"#9a9a9a"}}>
                        {contenidoGral()}
                        {/* contenidoHistorico() */}
                        <Col md ={12}><div className="custom-alert-info" style={{padding:5}}>Opciones de cambio de carrera</div></Col>
                        <Col md={12} className="custom-mt-10" align="center">
                            No posees Estado de Cuenta. Ponte en contacto con <strong>Administración</strong>
                        </Col>
                    </Row>
                )
            default:
                return(<div></div>)
        }
    }

    ayuda= () => {
        let detallesGral = () => (
            <Col md={12} align="justify">
                Para poder realizar este proceso es importante que no hayas hecho tu inscripción, en ese caso debes deirigirte al departamento de Control de Estudios
            </Col>
        )

        let detallesInscripcion = () => (
            <React.Fragment>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Detalles de la Inscripción</strong>
                </Col>
                <Col md={12} align="justify">
                    En esta seccion podrás ver que materias tienes inscritas para el periodo actual
                </Col>
            </React.Fragment>
        )

        let detallesHistorico= () => (
            <React.Fragment>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Detalles de Datos Históricos</strong>
                </Col>
                <Col md={12} align="justify">
                    En esta seccion podrás ver las materias cursadas en tu carrera actual
                </Col>
            </React.Fragment>
        )

        let detallesCambio= () => (
            <React.Fragment>
                <Col md={12}>
                    <strong style={{color:"#3472F7"}}>Opciones de Cambio de Carrera</strong>
                </Col>
                <Col md={12} align="justify">
                    Para realizar el cambio de carrera simplemente debes seleccionar la carrera a cambiar y presionar el botón
                    <button className="btn btn-primary btn-sm" style={{borderWidth: 1}}><i className="fa fa-edit"></i>Solicitar Cambio</button>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10" style={{fontSize:10}}>
                    Esta opción no puede deshacerse y no perderás las calificaciones obtenidas en tu carrera actual
                </Col>
            </React.Fragment>
        )

        let detallesCambioOk= () => (
            <React.Fragment>
                <Col md={12}>
                    <strong style={{color:"#3472F7"}}>Opciones de Cambio de Carrera</strong>
                </Col>
                <Col md={12} align="justify">
                    Como ya has realizado este proceso no es posible cambiarlo hasta que obtengas una respuesta de parte de Control de Estudios.
                </Col>
            </React.Fragment>
        )
            
        switch (statusEst) {
            case 1:
                return(
                    <React.Fragment>
                        <Row>
                            {detallesGral()}
                            <Line color="#CCC"/>
                            {detallesInscripcion()}
                            <Line color="#CCC"/>
                            {detallesHistorico()}
                        </Row>
                    </React.Fragment>
                )
            case 2:
                return(
                    <React.Fragment>
                        <Row>
                            {detallesGral()}
                            <Line color="#CCC"/>
                            {detallesHistorico()}
                            <Line color="#CCC"/>
                            {detallesCambio()}
                        </Row>
                    </React.Fragment>
                )
            case 3:
                return(
                    <React.Fragment>
                        <Row>
                            {detallesGral()}
                            <Line color="#CCC"/>
                            {detallesHistorico()}
                            <Line color="#CCC"/>
                            {detallesCambioOk()}
                        </Row>
                    </React.Fragment>
                )
            case 4:
                return(
                    <React.Fragment>
                        <Row>
                            {detallesGral()}
                            <Line color="#CCC"/>
                            {detallesHistorico()}
                            <Line color="#CCC"/>
                            {detallesCambioOk()}
                        </Row>
                    </React.Fragment>
                )
            case 6:
                return(
                    <React.Fragment>
                        <Row>
                            {detallesGral()}
                            <Line color="#CCC"/>
                            {detallesHistorico()}
                            <Line color="#CCC"/>
                            {detallesCambioOk()}
                        </Row>
                    </React.Fragment>
                )
        default:
            return(
                <React.Fragment>
                    <Row>
                        <Col md={12} align="center">
                            <i className="fa fa-spin fa-spinner"></i> Cargando Ayuda
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
        
    }

    cambiarCarrera = () => (e) => {
        let { carrera, valorCarreras } = this.state;
        this.setState({
            boton1: {
                icon:"fa fa-spinner fa-spin",
                text: "Espere"
            }
        })
        SolicitarCambio(carrera.id_carrera, valorCarreras, (resp) => {
            this.setState({
                openW: resp,
                boton1: {
                    icon: "fa fa-check",
                    text: "Si"
                }
            }, () => {
                consultaEst((resp) => {
                    statusEst = resp[1];
                    let nombre2 = resp[0].nombre_2;
                    let apellido2 = resp[0].apellido_2;
                    if (nombre2 === null) nombre2 = "";
                    if (apellido2 === null) apellido2 = "";
        
                    this.setState({
                      est:{
                          ci:`${resp[0].nacionalidad} ${resp[0].ci}`,
                          name: `${resp[0].nombre_1} ${nombre2} ${resp[0].apellido_1} ${apellido2}`
                      },
                      status: resp[2],
                      materiasHistorico: resp[3],
                      carrera: resp[4],
                      carreras: resp[5],
                      carrCambio: resp[6]
                    })
                })
                toast.info("Cambio realizado con éxito, debes esperar que Control de Estudios la apruebe",{autoClose: 4000});
            })
        })
    }

    showModal = () => {
        let { carrera, valorCarreras, openW, boton1, valorCambioCarr } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>Deseas realmente solicitar el cambio de carrera de:</div>
                <div align="center" className="custom-alert-info custom-mt-10"><strong className="text-danger">{carrera.carrera_name}</strong> a <strong>{valorCarreras.label}</strong></div>
                <div style={{fontSize:10}} className="custom-mt-10">Esta opción no puede deshacerse</div>
                <div style={{fontSize:12}}>Este trámite tiene un costo de <strong className="text-danger">{valorCambioCarr.uc} U.C.</strong> o <strong className="text-danger">{formatNumber(valorCambioCarr.bs)} Bs.{/*  | {formatReconver(valorCambioCarr.bs)} Bs. */}</strong> y se añadirá  automáticamente a tu estado de cuenta</div>
            </React.Fragment>
        )

        return (
            <CustomModal
                isopen =  {openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className={boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.cambiarCarrera()}
                funcion2 = {() => {this.setState({openW: false})}}/>
        );
    }

    render() {
        let { status } = this.state;
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <div className={status.class} style={{padding:10}}>
                                <Row>
                                    <Col md={11}><div style={{fontSize:14}}>{status.text}</div></Col>
                                    <Col md={1}><i className={status.icon} style={status.styles}></i></Col>
                                </Row>
                            </div>
                            <Row className="custom-mt-10">
                                <Col md={12}>{this.contenido()}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Cambio de Carrera</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.showModal()}
            </React.Fragment>
        );
    }
}
 
export default CambioCarrera;


// WEBPACK FOOTER //
// ./src/views/EstAcademicos/CambioCarrera.jsx